import React from "react";
import { Text, Box, VStack, HStack, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface EvidenceCard {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  matchPercentage: number;
}

const MSDSTab: React.FC = () => {
  const { t } = useTranslation("common");

  // Static data - will be replaced with API data later
  const msdsCards: EvidenceCard[] = [
    {
      id: "1",
      title: "MSDS-001",
      subtitle: "Material Safety Data Sheet",
      description:
        "Safety information for chemical substances including hazard identification, composition, first aid measures, and handling precautions.",
      matchPercentage: 88,
    },
    {
      id: "2",
      title: "MSDS-002",
      subtitle: "Chemical Safety Information",
      description:
        "Detailed safety protocols for handling hazardous materials including personal protective equipment requirements and emergency procedures.",
      matchPercentage: 92,
    },
  ];

  return (
    <VStack spacing={4} align="stretch">
      {msdsCards?.map((card) => (
        <Box
          key={card.id}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="8px"
          p={4}
          position="relative"
        >
          <HStack justify="space-between" align="start" mb={2}>
            <VStack align="start" spacing={1}>
              <Text fontSize="16px" fontWeight="700" color="#1A202C">
                {card?.title}
              </Text>
              <Text fontSize="14px" color="#6B7280">
                {card?.subtitle}
              </Text>
            </VStack>
            <Badge
              bg="transparent"
              color="#005EB8"
              border="1px solid #005EB8"
              borderRadius="4px"
              px={2}
              py={1}
              fontSize="12px"
              fontWeight="500"
            >
              {t("evidenceReview.matchPercentage", {
                percentage: card?.matchPercentage,
              })}
            </Badge>
          </HStack>
          <Text fontSize="14px" color="#374151" lineHeight="1.5">
            {card?.description}
          </Text>
        </Box>
      ))}
    </VStack>
  );
};

export default MSDSTab;
